import { useState } from "react";
import { Box, Button, color, Flex, Input, Text } from "@chakra-ui/react";
import moment from "moment";
import { VARIANT } from "../constants/colors";
import { customColors } from "../atoms/customColors";
import { useRecoilState } from "recoil";

export default function DateDropdown({ filtros, setFiltros }: any) {
  const [open, setOpen] = useState(false);
  const [colors] = useRecoilState(customColors);
  const [filtroInterno, setFiltroInterno] = useState({
    initialDateFilter:
      filtros.initialDateFilter ||
      moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS"),
    finalDateFilter:
      filtros.finalDateFilter ||
      moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS"),
  });

  function mudarData() {
    setFiltros({
      ...filtros,
      initialDateFilter: filtroInterno.initialDateFilter,
      finalDateFilter: filtroInterno.finalDateFilter,
    });
  }

  return (
    <Box position="relative">
      <Button
        minWidth="280px"
        bgColor={colors.BLUEMONEDDBUTTONS}
        color="white"
        fontSize="1.8vh"
        minHeight="35px"
        px="10px"
        borderRadius="8px"
        onClick={() => setOpen(!open)}
      >
        {filtros.initialDateFilter && filtros.finalDateFilter
          ? `Filtrar por Data: ${moment(filtros.initialDateFilter).format(
            "DD/MM/YYYY"
          )}-${moment(filtros.finalDateFilter).format("DD/MM/YYYY")}`
          : `Filtrar por Data`}
      </Button>

      {open && (
        <Box
          position="absolute"
          bgColor="white"
          borderRadius="8px"
          boxShadow="md"
          p={4}
          mt={2}
          minWidth="280px"
          zIndex={1000} // Adicionado zIndex alto
        >
          <Flex direction="column" gap={3}>
            <Text fontWeight="bold">Data</Text>

            <Button
              onClick={() =>
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment()
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  finalDateFilter: moment()
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                })
              }
            >
              <Text color={VARIANT}>HOJE</Text>
            </Button>

            <Button
              onClick={() =>
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment()
                    .subtract(1, "day")
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  finalDateFilter: moment()
                    .subtract(1, "day")
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                })
              }
            >
              <Text color={VARIANT}>ONTEM</Text>
            </Button>

            <Button
              onClick={() =>
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment()
                    .subtract(7, "days")
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  finalDateFilter: moment()
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                })
              }
            >
              <Text color={VARIANT}>ÚLTIMOS 7 DIAS</Text>
            </Button>

            <Button
              onClick={() =>
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment()
                    .subtract(15, "days")
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  finalDateFilter: moment()
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                })
              }
            >
              <Text>ÚLTIMOS 15 DIAS</Text>
            </Button>

            <Button
              onClick={() =>
                setFiltroInterno({
                  ...filtroInterno,
                  initialDateFilter: moment()
                    .subtract(30, "days")
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  finalDateFilter: moment()
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                })
              }
            >
              <Text>ÚLTIMOS 30 DIAS</Text>
            </Button>

            <Flex direction="column" gap={2} mt={4}>
              <Text fontWeight="bold">De</Text>
              <Input
                type="date"
                value={moment(filtroInterno.initialDateFilter).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => {
                  const newDate = e.target.value;
                  setFiltroInterno({
                    ...filtroInterno,
                    initialDateFilter: moment(newDate)
                      .startOf("day")
                      .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  });
                }}
              />
            </Flex>

            <Flex direction="column" gap={2} mt={4}>
              <Text fontWeight="bold">Até</Text>
              <Input
                type="date"
                value={moment(filtroInterno.finalDateFilter).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => {
                  const newDate = e.target.value;
                  setFiltroInterno({
                    ...filtroInterno,
                    finalDateFilter: moment(newDate)
                      .endOf("day")
                      .format("YYYY-MM-DDTHH:mm:ss.SSS"),
                  });
                }}
              />
            </Flex>

            <Flex w="100%" justifyContent="center" mt={4}>
              <Button
                bgColor={VARIANT}
                color="white"
                w="90%"
                onClick={() => {
                  setOpen(false);
                  mudarData();
                }}
              >
                Filtrar
              </Button>
            </Flex>
          </Flex>
        </Box>
      )}
    </Box>
  );
}
